import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Automation\CreateAutomationController::__invoke
* @see app/Http/Controllers/Automation/CreateAutomationController.php
* @route '/api/automation'
*/
const CreateAutomationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAutomationController.url(options),
    method: 'post',
})

CreateAutomationController.definition = {
    methods: ["post"],
    url: '/api/automation',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Automation\CreateAutomationController::__invoke
* @see app/Http/Controllers/Automation/CreateAutomationController.php
* @route '/api/automation'
*/
CreateAutomationController.url = (options?: RouteQueryOptions) => {
    return CreateAutomationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Automation\CreateAutomationController::__invoke
* @see app/Http/Controllers/Automation/CreateAutomationController.php
* @route '/api/automation'
*/
CreateAutomationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAutomationController.url(options),
    method: 'post',
})

export default CreateAutomationController